
<script>

import { defineComponent } from 'vue'
import CheckboxToggle from '@/ui/CheckboxToggle'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//components
import OnePhotoToComponent from './modalsEditor/photoToComponent'

//data
import { getPhotosPreview } from '@/services/servicePhoto';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ComponentPhoto',
	mixins: [ MixinGeneralFunct ],
	data() {
		return {
			result: [],
			photos: [],
			photoId: '',
			photoIds: [],
			workContent:{}
			,paddingBottom: 0
			,showName: false
			,modalPhotoToArticleID:''
			,photoToArticleMODAL:{}
		}
	},
  props: {
	'content': Object
  },
  emits: ["content","changeContent"],
  components: {
    OnePhotoToComponent
	,CheckboxToggle
  }
	,mounted () {
		console.log(this.content.fields.photoId)
		this.photoId=this.content.fields.photoId;
		if(this.content.fields.showName){
			this.showName=this.content.fields.showName;
		}
		this.workContent = this.content;

		if(this.content.fields.paddingBottom){
			this.paddingBottom=this.content.fields.paddingBottom;
		}
		
		this.loadPreview();

		this.modalPhotoToArticleID = `modal${this.getRandomInt(999999999)}`;
	},

	methods: {
	
		//modal box select photos to article
		loadModalFormSelectPhoto:function(){
			this.photoToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalPhotoToArticleID), {backdrop:'static'})
			this.photoToArticleMODAL.show();
		},

		loadPreview:function(){
			
			if(this.workContent.fields.photoId){
				console.log(this.workContent.fields.photoId)
				getPhotosPreview({photoIds:this.workContent.fields.photoId}).then(response => {
					if(!response.statusText){
						this.photos = response.results;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.photos=[];
			}
		
		},

		sendContent:function(){
			console.log(this.workContent)
			this.workContent.content = JSON.stringify(this.workContent.fields);
			this.$emit('changeContent', this.workContent)
		},

		onChangePhotoId:function(){
			console.log(this.photoIds.join())
			this.workContent.fields.photoId=this.photoIds.join();
			this.sendContent();
		},

		onChangePaddingBottom:function(){
			console.log(this.paddingBottom)
			this.workContent.fields.paddingBottom=this.paddingBottom;
			this.sendContent();
		},

		onChangeShowName:function(e){
			this.workContent.fields.showName=e;
			this.sendContent();
		},

		//akcia po vybere fotky
		reloadAfterSelect(e) {
			this.photoId=e;
			let index = this.photoIds.findIndex((item) => item === e);
			if(index==-1){
				this.photoIds.push(e);
			}else{
				this.photoIds.splice(index, 1);
			}
			this.onChangePhotoId();
			this.loadPreview();
		},

	},
	
	watch: {
	
	},
	
	created() {

	}
})
</script>

<template>
  <div>
   
		<div class="col-12 mb-2 col-md-4">
			<label><b>{{ $t('msgCore.showName') }}</b></label>
			<CheckboxToggle :key="`photoDesc${photoId}`" :data="showName" @onClick="onChangeShowName"></CheckboxToggle>
		</div>

		<div class="col-12 mb-2 col-md-4">
			
			<button type="button" v-on:click="loadModalFormSelectPhoto()" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnSelectPhoto') }}</button>
			
		</div>

		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.paddingBottom') }}</b></label><br>
			
			<div v-for="(option) in 5" :key="option" class="form-check-inline">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" :name="`paddingBottom${photoId}`" v-model='paddingBottom' v-on:change="onChangePaddingBottom()" :value="option">
					{{ option }}
					<span class="circle">
						<span class="check"></span>
					</span>
				</label>
			</div>
			
		</div>

		<div v-for="(photo) in photos" :key="photo" class="col-md-3 col-12">
			<a class="fancybox" data-fancybox="gallery" :href="photo.photoDataOrigo"><img class="img-fluid" :src="photo.photoDataOrigo"></a>
		</div>

			

		<OnePhotoToComponent  :modalId="modalPhotoToArticleID" @changeAfterSelect="reloadAfterSelect" :modalObject="photoToArticleMODAL"></OnePhotoToComponent>
  </div>
</template>